import React, { useState, useEffect } from 'react';
import AppointmentMobile from './appointmentMobile';
import AppointmentWeb from './appointmentWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const AppointmentVerification = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <AppointmentMobile /> : <AppointmentWeb />;
};

export default AppointmentVerification;
